import { type PropsWithChildren } from "react";
import * as S from "./ToggleWrapper.styled";
import { SizedProps } from "../types";

type ToggleWrapperProps = PropsWithChildren & SizedProps;

export function ToggleWrapper(props: ToggleWrapperProps) {
  const { children, toggleSize } = props;

  return (
    <S.ToggleOutlineWrapper $toggleSize={toggleSize}>
      <S.CustomToggleWrapper $toggleSize={toggleSize}>
        {children}
      </S.CustomToggleWrapper>
    </S.ToggleOutlineWrapper>
  );
}

export default ToggleWrapper;
